import * as React from 'react'
import { Button } from 'react-bootstrap'

import { Document, Page, pdfjs } from 'react-pdf'
import documents from '../../../../../constants/documents';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`

interface ConsumerRightsAndResponsibilitiesProps { }

const ConsumerRightsAndResponsibilities: React.FunctionComponent<ConsumerRightsAndResponsibilitiesProps> = ({ }): JSX.Element => {
    let [numPages, setNumPages] = React.useState(0)
    let [pageNumber, setPageNumber] = React.useState(1)

    const onDocumentLoadSuccess = ({ numP }): void => {
        console.log('numP: ', numP)
        setNumPages(numP)
    }

    const pageButtons = (): JSX.Element => {
        return (
            <span>
                <Button
                    disabled={pageNumber == 1 ? true : false}
                    onClick={(): void => { setPageNumber(--pageNumber) }}
                    variant='light'>
                    Prev
                </Button>
                <span>{pageNumber} of 27</span> {/* TODO: Convert 27 to dynamicly read page number */}
                <Button
                    disabled={pageNumber == 27 ? true : false}
                    onClick={(): void => { setPageNumber(++pageNumber) }}
                    variant='light'>
                    Next
                </Button>
            </span>
        )
    }

    return (
        <div>

            {pageButtons()}
            <Document
                file={documents.rightsAndResponsibilities2013}
                onLoadError={console.error}
                onLoadSuccess={onDocumentLoadSuccess}>
                <Page pageNumber={pageNumber} />
            </Document>
            {pageButtons()}
        </div>
    )
}

export default ConsumerRightsAndResponsibilities
